import React from 'react';
import { useTranslation } from 'react-i18next';
import OpenDebtsCard from 'components/reusable/report/cards/OpenDebtsCard';
import CollapsibleCard from '../../../../../components/reusable/CollapsibleCard';
import { Row } from 'antd';
import { useSelector } from 'react-redux';
import { summaryInformation } from '../../../../../store/entities/companySearchResult/selectors/unregisteredReportSelector';
import { handleNegativeClass } from '../helpers';

const OpenDebts = () => {
  const { t } = useTranslation();
  const { summaryInformation: summaryInformationState } = useSelector(summaryInformation);

  const negativeClass =
    handleNegativeClass(summaryInformationState?.paidDebts?.total, summaryInformationState?.paidDebts?.latestDate) ||
    summaryInformationState?.paidDebts?.activeDebts;

  const activeDebts = {
    companyCode: 111689163,
    creditinfoId: 142803,
    total: 'mock',
    latestDate: '2025-02-26T00:00:00Z',
    averageDays: 816,
    amount: 2025334.45,
  };

  return (
    <div className="content-blur">
      <OpenDebtsCard openDebtsData={activeDebts} isNegative={negativeClass}>
        <Row className="space-top-md">
          <CollapsibleCard
            hideByDefault={true}
            title={t('professionalReport.basicData.managersChangeHistory.historicalInformation.title')}
          />
        </Row>
      </OpenDebtsCard>
    </div>
  );
};

export default OpenDebts;
